import { sendRequest } from '../api/websocketApi';
import useStore from '../store/store';

interface SendQuestionParams {
    title: string;
    content: string;
    sender?: string;
}

interface APIResponse {
    success: boolean;
    errCode?: 'invalid_param' | 'invalid_token' | 'auth_failed';
    errDetails?: string;
}

const SendQuestion = (params: SendQuestionParams) => {
    const setFormError = useStore.getState().setFormError;
    const setSuccessMessage = useStore.getState().setSuccessMessage;
    const setIsLoading = useStore.getState().setIsLoading;

    setIsLoading(true);
    sendRequest(
        {
            endpoint: '/contact/send-question',
            body: params,
        },
        (data: APIResponse) => {
            const { success, errCode, errDetails } = data;
            if (success) {
                setSuccessMessage('Message sent, thank you!');
            } else if (!success && errCode) {
                setFormError('');
                setTimeout(() => setFormError(errCode), 0);
                console.error(errCode);
                if (errDetails) console.error(errDetails);
            }
            setIsLoading(false);
        }
    );
};

export default SendQuestion;
